/**
 * The Outstanding filter bar's chip look, lit when the chip is doing something
 * — a visitor picked, a sort other than newest first.
 *
 * ONE border colour, SWAPPED, never appended. `border-subtle` and
 * `border-primary` each set only `border-color` at the same specificity, so the
 * one that wins is whichever Tailwind emits later — and it emits
 * `border-subtle` after both `border-primary` and
 * `border-[var(--brand-primary)]`. Appending the accent to a class list that
 * already said `border-subtle` is how the visitor chip and the sort control
 * (review, 2026-09-23) both came to show no cue at all.
 */
const CHIP_BASE =
  'inline-flex min-h-9 items-center gap-2 rounded-control border bg-input px-3 text-sm text-content transition-colors hover:bg-hover';

export function filterChipClass(active = false): string {
  return `${CHIP_BASE} ${active ? 'border-primary' : 'border-subtle'}`;
}
